import React, { useState, useEffect, useCallback } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col, Pagination, Card, Button, Select, Typography, MenuProps, message } from "antd";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import Grid from "../../atoms/Grid";
import { useDispatch, useSelector } from "react-redux";
import { getTenants, sendInvite, activeDeActiveUser } from "./ducks/actions";
import { useNavigate } from "react-router-dom";
import { FilterOutlined, MailOutlined } from "@ant-design/icons";
import { PopupConfirm } from "../../atoms/Popup";
import Title from "antd/es/typography/Title";
import { Popup } from "../../atoms/Popup";
import AddLease from "./components/AddLease/AddLease";
import Modal from "./components/Modal/Modal";
import AddBilling from "./components/AddBilling/AddBilling";
import AddPayment from "./components/AddPayment/AddPayment";
import { getPropertiesDrop } from "../Properties/ducks/actions";
import {
  emptyPropertyUnits,
  getBookingUnitList,
  getPropertyUnits,
} from "../Properties/PropertyDetail/ducks/actions";
import { listFilterConfigWithPortfolioUnits } from "../../../utils/helper";
import { BookingFiltersState, FilterOption, useListingFilters } from "../../../hooks/useListingFilters";
import { useSearchHistory } from "../../../utils/filterHelper";
import { setFilterTenant } from "../App/SearchFilters/ducks/actions";
import LoaderTsx from "../Loader.tsx";
import { searchByOptions as baseSearchByOptions } from "./constants/searchByOptions";
import { useFeatureToggleSearchByOptions } from "../../../hooks/search";
import { useTenantsSearch } from "./hooks";

const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 200,
};

const limit = 50;

export default React.memo(() => {
  const dispatch: any = useDispatch();
  const id = location.pathname?.split("/")[2];
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const tenantApi = useSelector((state: any) => state.tenants.tenantList);
  const propertyList = useSelector((state: any) => state.dashboard.propertiesDrop || []);
  const bookingUnits = useSelector((state: any) => state.propertyDetails.bookingUnitsDropdown || []);
  const portfolioUnits = useSelector((state: any) => state.propertyDetails.unitsDropdown || []);
  const propertyOptions: FilterOption[] = propertyList;
  const [unitLoading, setUnitLoading] = useState(false);

  const userInformation = JSON.parse(localStorage.getItem("login-response"));

  const Filter = useSelector((state: any) => state.filters.tenantsData);

  const { searchHistory, addToSearchHistory } = useSearchHistory(setFilterTenant);

  const [searchBy, setSearchBy] = useState(Object.keys(Filter)[0] ?? "name");
  const [search, setSearch] = useState(Filter[Object.keys(Filter)[0]] ?? "");

  const [visible, setVisible] = useState(false);
  const [singleInvite, setSingleInvite] = useState(null);
  const [trigger, setTrigger] = useState(0);
  const [selectedTenants, setSelectedTenants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deselectAll, setDeselectAll] = useState(false);
  const [tenantStatus, setTenantStatus] = useState(null);
  const [tenantLoading, setTenantLoading] = useState(null);

  const [setSelect, setSelectValue] = React?.useState(false);
  const [selectedSearchBy, setSelectedSearchBy] = useState(Object.keys(Filter)[0] ?? "name");
  const [searchValue, setSearchValue] = useState(Filter[Object.keys(Filter)[0]] ?? "");

  const { selectOptions, handleSearch, handleChangeSearchBy } = useTenantsSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });

  const tenantsFilterConfig = useCallback(
    (state: BookingFiltersState) =>
      listFilterConfigWithPortfolioUnits({
        state,
        propertyOptions,
        portfolioUnits,
        bookingUnits,
        portfolioUnitsLoading: unitLoading,
      }),
    [propertyOptions, portfolioUnits, bookingUnits, unitLoading],
  );

  const {
    viewOption: listingFilterOptions,
    handleFilterChange: hookFilterChange,
    updateValue,
    filtersState,
  } = useListingFilters<BookingFiltersState>({
    initialState: {
      usagesType: { value: "all", label: "All" },
      property: { value: "all", label: "All" },
      unit: { value: "all", label: "All" },
    },
    configBuilder: tenantsFilterConfig,
    handlers: {
      property: ({ option, setState, setUpdateValue }) => {
        setState((prev) => ({
          ...prev,
          property: option,
          unit: null,
        }));
        setUpdateValue({ label: "unit", value: null });
        const pid = option?.value;
        if (pid && pid !== "all" && pid !== "") {
          dispatch(getBookingUnitList(pid));
        } else {
          dispatch(getPropertyUnits(null, null, null, setUnitLoading));
        }
      },
    },
    sections: { usagesType: false },
  });

  const filterStatus = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Registered",
      value: "registered",
    },
    {
      label: "Not registered",
      value: "not_registered",
    },
    {
      label: "Inactive/Deleted",
      value: "inactive_deleted",
    },
    {
      label: "Blacklisted",
      value: "isBlocked",
    },
  ];

  const MenuItems: MenuProps["items"] = [
    {
      label: "Active Tenancy",
      key: 0,
    },

    {
      label: "Payment Schedule",
      key: 2,
    },
  ];

  useEffect(() => {
    dispatch(getPropertiesDrop());
    dispatch(getPropertyUnits(null, null, null, setUnitLoading));
    return () => {
      dispatch(emptyPropertyUnits());
    };
  }, []);

  const onDropClick: MenuProps["onClick"] = ({ key }) => {
    setVisible(true);
    setTrigger(+key);
  };

  const getTenantsData = () => {
    let filter: any = {};

    const pVal = filtersState.property?.value;
    const uVal = filtersState.unit?.value;

    if (pVal && pVal !== "all" && pVal !== "" && pVal != null) {
      filter.propertyId = pVal;
    }

    if (uVal && uVal !== "all" && uVal !== "" && uVal != null) {
      filter.unitId = uVal;
    }

    // ✅ Add tenant status (always merges with property/unit if present)
    if (tenantStatus) {
      switch (tenantStatus) {
        case "registered":
          filter.registered = true;
          break;
        case "not_registered":
          filter.registered = false;
          break;
        case "inactive_deleted":
          filter.InactiveDeleted = true;
          break;
        case "isBlocked":
          filter.isBlocked = "yes";
          break;
      }
    }
    dispatch(getTenants(id, limit, currentPage, searchValue, selectedSearchBy, filter, setTenantLoading));
  };

  const MoreAction = (record) => {
    const navigate: any = useNavigate();

    const onChangeHandler = async (e) => {
      if (e === "send_invitation") {
        setVisible(true);
        setTrigger(4);
        console.log(record.data, "recorddata");
        setSingleInvite(record.data);
      } else if (e === "view_file") {
        navigate(`/tenants-detail/${record.data._id}`);
      } else if (e === "restore" || e === "deactivate") {
        PopupConfirm({
          title: `Are you sure you want to ${e === "restore" ? "Restore" : "Deactivated"} ${record?.data?.name}?`,
          onOk: async () => {
            let deleteStatus = record?.data?.isDeleted ? "false" : "true";
            let result = await activeDeActiveUser({ isDeleted: deleteStatus }, record?.data?._id);

            if (result === 200) {
              message.success(`${record?.data?.name} ${e === "restore" ? "Restore" : "Deactivated"} successfully`);
              getTenantsData();
            }
          },
          onCancel: () => {
            setSelectValue(!setSelect);
          },
          okText: "Yes",
        });
      }
    };

    const { Text } = Typography;
    return (
      <Select
        onChange={onChangeHandler}
        className="Sentence"
        placeholder="Select an action"
        style={{ width: 150 }}
        allowClear
      >
        <>
          <React.Fragment>
            <Select.Option value={"view_file"}>
              <Text>View File</Text>
            </Select.Option>
            {!record.data.isSignUp && (
              <Select.Option value={"send_invitation"}>
                <Text>Send Invitation</Text>
              </Select.Option>
            )}

            {record.data?.isDeleted && userInformation?.canDeactivateRestore && (
              <Select.Option value={"restore"}>
                <Text>Restore Tenant</Text>
              </Select.Option>
            )}

            {!record.data?.isDeleted && userInformation?.canDeactivateRestore && (
              <Select.Option value={"deactivate"}>
                <Text>Deactivate</Text>
              </Select.Option>
            )}
          </React.Fragment>
        </>
      </Select>
    );
  };

  const tenantCol = [
    {
      headerName: "Tenant Name",
      field: "name",
      checkboxSelection: (params) => {
        return !params.data.isSignUp;
      },
      headerCheckboxSelection: true,
      // minWidth: screenSize === "xl" ? 350 : 250,
      flex: 1,
    },
    // {
    //   headerName: "Property Name",
    //   field: "propertyName",
    //   minWidth: screenSize === "xl" ? 350 : 200,
    // },
    // {
    //   headerName: "Unit Code",
    //   field: "unitCode",
    //   minWidth: screenSize === "xl" ? 350 : 200,
    // },
    {
      headerName: "Mobile Number",
      field: "mobile",
      // minWidth: screenSize === "xl" ? 350 : 200,
      flex: 1,
    },
    {
      headerName: "Email",
      field: "email",
      // minWidth: screenSize === "xl" ? 350 : 250,
      flex: 1,
    },
    {
      headerName: "Registered",
      field: "isSignUp",
      // minWidth: screenSize === "xl" ? 350 : 180,
      flex: 1,
      cellRenderer: (params) => (params.data.isSignUp ? "Yes" : "No"),
    },
    // {
    //   headerName: "Property",
    //   field: "propertyId",
    //   flex: 1,
    //   // minWidth: screenSize === "xl" ? 350 : 180,
    //   cellRenderer: (params) => console.log(params?.data, "paramsdata"),
    // },
    {
      headerName: "View Details",
      cellRendererFramework: MoreAction,
      // cellStyle: { textAlign: "center" },
      filter: false,
      // minWidth: screenSize === "xl" ? 350 : 180,
      flex: 1,
    },
  ];

  const onAdd = () => {
    dispatch(getTenants(id, limit, currentPage, "", "", "", setTenantLoading));
  };

  const handelSendInvitepayload = (tenants) => {
    const tenantsIds = tenants
      .filter((t) => !t?.data?.isSignUp)
      .map((t) => {
        return {
          email: t.data.email,
          propertyId: t.data.propertyId,
          usertype: "tenant",
          inviteAll: false,
        };
      });
    console.log(tenantsIds, "tenantsIds");
    setSelectedTenants(tenantsIds);
  };

  const onSelectionChanged = (event) => {
    const tenants = event.api.getSelectedNodes();
    if (tenants.length > 0) {
      handelSendInvitepayload(tenants);
    } else {
      setSelectedTenants([]);
    }
  };

  const onSendInvite = async (data) => {
    setVisible(false);
    let successMessage = "";
    setLoading(true);

    let payload: any = {};

    if (data.email) {
      payload = [
        {
          email: data.email,
          propertyId: data.propertyId,
          inviteAll: false,
          userType: "tenant",
        },
      ];
      successMessage = "Invite sent to tenant successfully";
    } else if (selectedTenants.length > 0) {
      payload = selectedTenants;
      successMessage = "Invite sent to selected tenants successfully";
    } else {
      payload.inviteAll = true;
      successMessage = "Invite sent to all tenants successfully";
    }

    const status = await sendInvite(payload, successMessage);
    setLoading(false);
    if (status === 200) {
      message.success(successMessage);
      setDeselectAll(true);
      //Can be placed at better re-rendering location
      setTimeout(() => {
        setDeselectAll(false);
      }, 1500);
    }
  };

  const handlePagination = (pg) => {
    setCurrentPage(pg);
  };

  useEffect(() => {
    if (tenantApi?.data) {
      let temp = [];
      tenantApi?.data?.map((item) => {
        temp.push({
          _id: item.userId,
          name: item.name,
          mobile: item.mobile,
          email: item.email,
          isSignUp: item.isSignUp,
          isDeleted: item?.isDeleted,
          propertyId: item.propertyId,
        });
      });
      setData(temp);
    } else {
      setData([]);
    }
  }, [tenantApi]);

  useEffect(() => {
    addToSearchHistory(selectedSearchBy, searchValue); //adding search history and filter store
    getTenantsData();
  }, [searchValue, filtersState.property?.value, filtersState.unit?.value, tenantStatus, currentPage]);

  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);

  useEffect(() => {
    let key = Object.keys(searchHistory)[0];
    if (searchByOptions.length > 0)
      searchByOptions.map((item) => {
        if (key == item.value) item["default"] = true;
        else item["default"] = false;
        return item;
      });
  }, [searchHistory]);

  const handleViewFilter = (selected, name) => {
    setCurrentPage(1);
    if (name === "property" || name === "unit") {
      hookFilterChange(selected, name);
      return;
    }
    if (name === "status") {
      const status = filterStatus?.find((item) => item?.value === selected?.value);
      if (status?.value) {
        setTenantStatus(status.value);
      }
    }
  };

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          Add New Active Tenancy
        </Title>
      ),
      content: <AddLease onSubmit={onAdd} />,
      width: 650,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Add New Billing Schedule
        </Title>
      ),
      content: <AddBilling />,
      width: 650,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Add New Payment Schedule
        </Title>
      ),
      content: <AddPayment />,
      width: 650,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Send Invite
        </Title>
      ),
      content: (
        <Modal
          title="Are you sure you would like to send invitations to the selected tenants ?"
          onSubmit={() => onSendInvite({ email: "" })}
        />
      ),
      width: 650,
    },
    {
      title: (
        <Title level={3} className="m-0">
          Send Invite
        </Title>
      ),
      content: (
        <Modal
          title="Are you sure you would like to send invitation to the selected tenant ?"
          onSubmit={() => onSendInvite(singleInvite)}
        />
      ),
      width: 650,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };

  return (
    <>
      <DashboardLayout load={loading}>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <SectionHeaderV2
                  heading="Tenants"
                  noBorder={true}
                  total={tenantApi?.totalCount || 0}
                  dropNewAction={onDropClick}
                  dropItems={MenuItems}
                  dropTrigger={["click"]}
                  onSearch={handleSearch}
                  onChangeSearchBy={handleChangeSearchBy}
                  defaultSearch={searchValue}
                  searchByOptions={searchByOptions}
                  selectOptions={selectOptions}
                  viewOption={[
                    ...listingFilterOptions,
                    { name: "status", label: "Status", options: filterStatus, search: true },
                  ]}
                  viewOptionIcon={<FilterOutlined />}
                  // viewOptionLabel="Filter by : property/unit"
                  justifiedItems={true}
                  updateValue={updateValue}
                  justifyEnd={true}
                  handleView={handleViewFilter}
                />
              </Col>
              <Col span={24}>
                <Pagination
                  pageSize={limit}
                  className="ag-property-text-pagination"
                  total={tenantApi?.totalCount || 0}
                  showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Tenants`}
                  defaultPageSize={tenantApi?.perPage}
                  defaultCurrent={1}
                  showSizeChanger={false}
                  current={currentPage}
                  onChange={(e) => handlePagination(e)}
                />
              </Col>
              <Col span={24} className="managers_tenants_detail" style={{ width: "100%" }}>
                {tenantLoading ? (
                  <LoaderTsx />
                ) : (
                  <Card style={{ width: "100%" }} bordered={false} className="ag-nospace-body">
                    <div className="send-invite">
                      <Button
                        type="primary"
                        icon={<MailOutlined />}
                        onClick={() => {
                          setVisible(true);
                          setTrigger(3);
                        }}
                        disabled={!(selectedTenants.length > 0)}
                      >
                        {selectedTenants.length > 0 ? "Invite Selected Tentants" : "Invite All"}
                      </Button>
                    </div>
                    <Grid
                      data={data}
                      gridClassName="full-width-grid"
                      columns={tenantCol}
                      pagination={false}
                      defaultSettings={gridProps}
                      noRowlabel="Tenants"
                      rowSelection="multiple"
                      onSelectionChanged={onSelectionChanged}
                      isRowSelectable={false}
                      fullPage={true}
                      deselectAll={deselectAll}
                    />
                  </Card>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </DashboardLayout>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
});
